<template>
  <div :class="classes" :data-preload="[$options.name]">
    <div class="inner">
      <Toast />
    </div>
    <portal-target name="pdpStickyFooter" />

    <CookiesMain />
    <TwilioChat />
  </div>
</template>

<script>
import Toast from 'Components/02-molecules/toast/Toast';
import CookiesMain from 'Components/03-organisms/cookies-main/CookiesMain';
import globalMixin from 'Libs/mixins/globalMixin';
import TwilioChat from 'Src/components/03-organisms/twilio-chat/TwilioChat.vue';

export default {
  name: 'ViewportBottom',
  components: {
    Toast,
    CookiesMain,
    TwilioChat,
  },
  mixins: [globalMixin],
  data() {
    return {
      showCookiesBar: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import 'variables/breakpoints';
@import 'mixins';

.viewportBottom {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  z-index: 100000;
}

.inner {
  @include pageWidth;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: var(--space-1);
}
</style>
